module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-moderator-edbf3e2daef77e43ce922e897f5d317c.jpg";